export type ArchiveErrorCode =
  | 'not-archive'
  | 'header-too-large'
  | 'geojson-too-large'
  | 'photo-too-large'
  | 'compressed'
  | 'empty'
  | 'unsupported'
  | 'nested'
  | 'no-photos'
  | 'no-geojson'
  | 'bad-geojson'
  | 'no-features'
  | 'out-of-range'
  | 'photo-failed'
  | 'encrypted'
  | 'worker-failed'

export class ArchiveError extends Error {
  readonly code: ArchiveErrorCode
  readonly detail?: string

  constructor(code: ArchiveErrorCode, detail?: string) {
    super(detail ? `${code}: ${detail}` : code)
    this.name = 'ArchiveError'
    this.code = code
    this.detail = detail
  }
}

export const isArchiveError = (error: unknown): error is ArchiveError => error instanceof ArchiveError
